import {
  put, takeLatest, call, all, fork, select,
} from 'redux-saga/effects';
import { isFunction } from 'lodash';
import actions from '../actions/transactions';
import userActions from '../actions/user';
import rf from '../../requests/RequestFactory';

// saga effect
import {
  FETCH_WITHDRAWAL_HISTORY,
  WITHDRAWAL,
  FETCH_USER_VOLUME_24H,
  WITHDRAWAL_CUSTOM,
} from '../actions/transactions/action_types';
import { VERIFY_WITHDRAWAL } from '../actions/login/action_types';
import utils from '../../common/utils';

function* withdrawal(action) {
  try {
    const resp = yield call((params) => rf.getRequest('TransactionRequest').withdrawal(params), action.params.data);

    yield put(actions.onWithdrawalSucceed(resp.data));
    yield utils.showNotification(window.$t('common.notification'), window.$t('Withdraw succeeded'));
    // yield put(actions.onFetchTransactionHistory({
    //   pos: 0,
    //   count: 10,
    //   // 1 is withdrawal
    //   trans_type: 1,
    // }));
    // yield put(userActions.fetchUserBalancesAction());
  } catch (err) {
    yield put(actions.onWithdrawalFailed(err));
  } finally {
    if (action.callback) {
      yield action.callback();
    }
  }
}

function* withdrawalCustom(action) {
  try {
    const resp = yield call((params) => rf.getRequest('TransactionRequest').withdrawalCustom(params), action.params.data);

    yield put(actions.onWithdrawalCustomSucceed(resp.data));
    yield utils.showNotification(window.$t('common.notification'), window.$t('Withdraw succeeded'));
    // yield put(actions.onFetchTransactionHistory({
    //   pos: 0,
    //   count: 10,
    //   // 1 is withdrawal
    //   trans_type: 1,
    // }));
    // yield put(userActions.fetchUserBalancesAction());
  } catch (err) {
    yield put(actions.onWithdrawalCustomFailed(err));
  } finally {
    if (action.callback) {
      yield action.callback();
    }
  }
}

function* fetchWithdrawalHistory(action) {
  try {
    const resp = yield call((params) => rf.getRequest('TransactionRequest').fetchWithdrawalHistory(params), action.params.data);

    yield put(actions.onFetchTransactionHistorySucceed(resp.data, resp.total_count));
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.onFetchTransactionHistoryFailed(err));
  }
}

function* verifyWithdrawal(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('TransactionRequest').verifyWithdrawal(params), action.params.data);
    yield put(actions.verifyWithdrawalSucceed(data));
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.verifyWithdrawalFailed(err));
  }
}

function* fetchUserVolume24h({ params, forceFetch }) {
  try {
    const volume24h = yield select(({ trans }) => trans.userVolume24h[`${params.currency}`]);
    let data = volume24h;
    if (forceFetch || `${data}` == 'undefined') {
      const resp = yield call((params) => rf.getRequest('TransactionRequest').fetchUserVolume24h(params), params.data);
      data = resp.data;
    }

    yield put(actions.fetchUserVolume24hActionSucceed(data));
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.fetchUserVolume24hActionFailed(err));
  }
}

// function* filterTransaction(action){
//   try{
//     yield call((params) => rf.getRequest('TransactionRequest').filterTransaction(params), action.data);
//     if(isFunction(action.callback)){
//     }
//   }
//   catch(err)
//   yield action.f
// }

function* watchAllTransaction() {
  yield takeLatest(WITHDRAWAL, withdrawal);
  yield takeLatest(WITHDRAWAL_CUSTOM, withdrawalCustom);
  yield takeLatest(FETCH_WITHDRAWAL_HISTORY, fetchWithdrawalHistory);
  yield takeLatest(VERIFY_WITHDRAWAL, verifyWithdrawal);
  yield takeLatest(FETCH_USER_VOLUME_24H, fetchUserVolume24h);
}

export default function* rootSaga() {
  yield all([fork(watchAllTransaction)]);
}
